export default __webpack_public_path__ + "static/media/airtime.4c8653ac.png";